export default __webpack_public_path__ + "static/media/favicon_vema.61d8ce14.ico";